<ngx-datatable
    [columnMode]="ColumnMode.flex"
    [headerHeight]="50"
    [footerHeight]="50"
    rowHeight="auto"
    [treeFromRelation]="'manager'"
    [treeToRelation]="'name'"
    [rows]="rows"
    (treeAction)="onTreeAction($event)"
>
    <ngx-datatable-column name="Name" [flexGrow]="3" [isTreeColumn]="true">
        <ng-template let-value="value" ngx-datatable-cell-template>
            {{ value }}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Gender" [flexGrow]="1">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            {{ value }}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Age" [flexGrow]="1">
        <ng-template let-value="value" ngx-datatable-cell-template>
            {{ value }}
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>